import React from 'react'
import parse from 'html-react-parser'
import { Container, Space } from '@mantine/core'
import HeaderMain from 'components/UI/Headers/HeaderMain/HeaderMain'
import NavigationMain from 'components/UI/NavigationMain/NavigationMain'
import FooterMain from 'components/UI/FooterMain/FooterMain'
import HeaderPage from 'components/UI/Headers/HeaderPage/HeaderPage'
import BreadcrumbsMain from 'components/UI/Breadcrums/BreadcrumsMain/BreadcrumsMain'
import PageLoader from 'components/UI/PageLoader/PageLoader'
import ContentTypeArticle from './ContentTypeArticle'
import ContentTypeDocument from './ContentTypeDocument'
import useScreen from 'hooks/useScreen'
import styles from './styles.module.scss'

const Post = () => {
    const { pageData, referencedPosts, referencedPages } = useScreen()
    if (!pageData) {
        return <PageLoader />
    } else {
        const { data } = pageData
        const { title, summary, contentType } = data
        const fileExtension = data.links?.length > 0 ? data.links[0].url : null
        return (
            <div className={styles.layout}>
                <HeaderMain />
                <NavigationMain />
                <main>
                    <HeaderPage
                        title={title}
                        summary={summary}
                        theme='themeAmber'
                    />
                    <BreadcrumbsMain />
                    <Container size='1280px' px={0}>
                        {contentType === 'article' && (
                            <ContentTypeArticle data={data} />
                        )}
                        {contentType === 'card' && <div>Card</div>}
                        {contentType === 'document' && (
                            <ContentTypeDocument
                                data={data}
                                referencedPosts={referencedPosts}
                            />
                        )}
                    </Container>
                    <Space h='2x' />
                </main>
                <FooterMain />
            </div>
        )
    }
}

export default Post
